
import { mixin as clickaway } from 'vue-clickaway'
import InputCheckBox from '../input-checkbox/InputCheckbox'

export default {
    name: 'InputDropdownCheckbox',
    mixins: [ clickaway ],
    components: {
        InputCheckBox
    },

    data() {
        return {
            dropdownClass: 'input-dropdown-hidden',
            error: '',
            selectedValue: '',
            selectAll: false,
            filterClass: '',
            filterInputClass: '',
            sortedData: [],
            expanded: false
        }
    },

    props: {
        label: String,
        required: Boolean,
        placeholder: String,
        value: String,
        data: Array,
    },

    mounted() {
        this.sortedData = this.data
    },

    methods: {
        showItems() {
            this.expanded = true
            this.dropdownClass = ''
            this.filterClass = 'input-dropdown-filter-shown'
            this.filterInputClass = 'input-dropdown-filter-input-shown'
        },

        hideItems() {
            this.expanded = false
            this.dropdownClass = 'input-dropdown-hidden'
            this.sortedData = this.data
            this.filterClass = ''
            this.filterInputClass = ''
            this.value = undefined
            this.$emit('hide')
        },

        checkForError() {
            this.error = (this.value != '' && this.value != undefined) || this.selectedValue != '' || !this.required ? '' : 'input-dropdown-error'
        },

        toggleCheckbox(item) {
            item.checked = !item.checked
            this.$emit('change')
        },

        selectAllItems(){
            this.selectAll = !this.selectAll

            if (this.selectAll) {
                for (let item of this.data) {
                    item.checked = true
                }
                this.$emit('change')
            } else {
                for (let item of this.data) {
                    item.checked = false
                }
                this.$emit('change')
            }

        },
        updateValue(value) {
            this.clear = value != '' ? 'input-text-clear' : ''
            this.filter(value)
        },

        filter(searchValue) {
            this.sortedData = this.data.filter(item => {
                return item['value'].toLowerCase().includes(searchValue.toLowerCase())
            })
        },
    }
}
